import { Controller } from "@hotwired/stimulus"

// Controller generique pour les onglets avec aria-controls
// Supporte des classes actives/inactives configurables via Stimulus classes
// Usage: data-tabs-active-class="my-active" data-tabs-inactive-class="my-inactive"
// Par defaut utilise les classes admin (border-b-2, border-blue-600, etc.)
// Connects to data-controller="tabs"
export default class extends Controller {
  static targets = ["tab", "panel"]
  static classes = ["active", "inactive"]

  // Classes par defaut pour compatibilite ascendante (admin theme)
  static DEFAULT_ACTIVE = ["border-b-2", "border-blue-600", "text-blue-600", "font-semibold"]
  static DEFAULT_INACTIVE = ["text-gray-600"]

  get activeClasses() {
    return this.hasActiveClass ? this.activeClass.split(" ") : this.constructor.DEFAULT_ACTIVE
  }

  get inactiveClasses() {
    return this.hasInactiveClass ? this.inactiveClass.split(" ") : this.constructor.DEFAULT_INACTIVE
  }

  connect() {
    this.activate(this.tabTargets.find(tab => tab.getAttribute("aria-selected") === "true"))
  }

  change(event) {
    this.activate(event.currentTarget)
  }

  activate(tab) {
    if (!tab) return

    const name = tab.getAttribute("aria-controls")

    this.tabTargets.forEach(t => {
      t.setAttribute("aria-selected", "false")
      t.classList.remove(...this.activeClasses)
      t.classList.add(...this.inactiveClasses)
    })

    tab.setAttribute("aria-selected", "true")
    tab.classList.add(...this.activeClasses)
    tab.classList.remove(...this.inactiveClasses)

    this.panelTargets.forEach(p => {
      p.classList.toggle("hidden", p.id !== name)
    })
  }
}
